import { useContext, useEffect, useImperativeHandle } from "react";

import { useFormikContext } from "formik";

import Form from "./Form";
import ScheduleContext from "./ScheduleContext";
import { processFormValues, sortDays } from "./utils";

const Fields = ({ handleValuesChanged, scheduleRef }) => {
  const { firstDay } = useContext(ScheduleContext);
  const formikBag = useFormikContext();

  const { values, resetForm, errors } = formikBag;

  useEffect(() => {
    handleValuesChanged(processFormValues(values, firstDay), formikBag);
  }, [values]);

  useImperativeHandle(scheduleRef, () => ({ resetForm, errors }));

  return sortDays(firstDay).map(wday => <Form day={wday} key={wday} />);
};

export default Fields;
